import * as yup from "yup";

const decimalValidation = yup
  .number()
  .typeError("This field must be a valid number")
  .transform((value, originalValue) => {
    if (originalValue === "") return null;
    return value;
  })
  .test("max-decimals", "Only up to 5 decimal places are allowed", (value) => {
    if (value === undefined || value === null) return true;
    return /^(\d+(\.\d{1,5})?)?$/.test(value);
  })
  .nullable();

const numberValidation = yup
  .number()
  .typeError("This field must be a number")
  .min(0, "Negative numbers are not allowed")
  .nullable();

const integerValidation = yup
  .string()
  .matches(/^\d+$/, 'This field must be an integer')
  .test('is-integer', 'This field must be an integer', (value) => {
    if (value === null || value === '' || value === undefined) return true;
    if (typeof value === 'string' && value.includes('.')) return false;
    return /^\d+$/.test(value);
  })
  .typeError('This field must be a number')
  .nullable();

export const schema = [
  yup.object({
    remarks: yup
      .string()
      .max(250, "Remarks must be 250 characters or less"),

    number_of_deaths_today: integerValidation,
    number_of_injured_persons_today: integerValidation,
    number_of_houses_fully_damaged_today: integerValidation,
    number_of_houses_partially_damaged_today: integerValidation,
    number_of_people_rescued_today: integerValidation,
    number_of_relief_camps_today: integerValidation,
  }),
];

export const DailyEarthquakeFormConfig = [
  {
    id: 0,
    name: "",
    heading: "",
    fields: [
      {
        name: "date",
        label: "Date",
        type: "date",
        disabled: true,
      },
      {
        name: "district_name",
        label: "Name of District",
        type: "input",
        disabled: true,
      },
      {
        name: "block_name",
        label: "Block",
        type: "input",
        disabled: true,
      },
      {
        name: "number_of_deaths_today",
        label: "Number of Deaths due to Earthquake (Today)",
        type: "input",
      },
      {
        name: "number_of_deaths_cumulative",
        label: "Number of Deaths due to Earthquake (Cumulative)",
        type: "input",
        disabled: true,
      },
      {
        name: "number_of_injured_persons_today",
        label: "Number of Injured Persons (Today)",
        type: "input",
      },
      {
        name: "number_of_injured_persons_cumulative",
        label: "Number of Injured Persons (Cumulative)",
        type: "input",
        disabled: true,
      },
      {
        name: "number_of_houses_fully_damaged_today",
        label: "Number of Houses Fully Damaged (Today)",
        type: "input",
      },
      {
        name: "number_of_houses_fully_damaged_cumulative",
        label: "Number of Houses Fully Damaged (Cumulative)",
        type: "input",
        disabled: true,
      },
      {
        name: "number_of_houses_partially_damaged_today",
        label: "Number of Houses Partially Damaged (Today)",
        type: "input",
      },
      {
        name: "number_of_houses_partially_damaged_cumulative",
        label: "Number of Houses Partially Damaged (Cumulative)",
        type: "input",
        disabled: true,
      },
      {
        name: "number_of_people_rescued_today",
        label: "Number of People Rescued (Today)",
        type: "input",
      },
      {
        name: "number_of_people_rescued_cumulative",
        label: "Number of People Rescued (Cumulative)",
        type: "input",
        disabled: true,
      },
      {
        name: "number_of_relief_camps_today",
        label: "Number of Relief Camps (Today)",
        type: "input",
      },
      {
        name: "number_of_relief_camps_cumulative",
        label: "Number of Relief Camps (Cumulative)",
        type: "input",
        disabled: true,
      },
      {
        name: "remarks",
        label: "Remarks",
        type: "text_area",
        maxLength: 250,
      },
    ],
  },
];